import React from 'react'

export default function BufSpan() {
  return (
    <span style={{paddingLeft: 8}}/>
  )
}
